import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const cultivars = [
  {
    name: "AV Gas",
    route: "/cultivars/av-gas",
    image: "/images/av-gas.png",
    description: "A high-octane strain with bold flavors and potent effects.",
  },
  {
    name: "Blackberry Moonrocks",
    route: "/cultivars/blackberry-moonrocks",
    image: "/images/blackberry-moonrocks.png",
    description: "Rich blackberry aroma with a powerful, long-lasting high.",
  },
  {
    name: "Bubba",
    route: "/cultivars/bubba",
    image: "/images/bubba-kush.png",
    description:
      "A classic strain known for its earthy flavor and deep relaxation.",
  },
  {
    name: "Cadillac Rainbows",
    route: "/cultivars/cadillac-rainbows",
    image: "/images/cadillac-rainbows.png",
    description: "Colorful and vibrant with a sweet, fruity aroma.",
  },
  {
    name: "Chemical Bromance",
    route: "/cultivars/chemical-bromance",
    image: "/images/chem-de-la-chem.png",
    description: "Potent and gassy, perfect for those who love strong effects.",
  },
  {
    name: "Donkey Butter",
    route: "/cultivars/donkey-butter",
    image: "/images/donkey-butter.png",
    description: "A pungent and relaxing strain with a creamy, nutty flavor.",
  },

  {
    name: "Fast Orange",
    route: "/cultivars/fast-orange",
    image: "/images/fast-orange.png",
    description: "Citrus-forward strain with an uplifting and energetic high.",
  },
  {
    name: "Fruity Pebbles 2.0",
    route: "/cultivars/fruity-pebbles-2-0",
    image: "/images/fruity-pebbles-2-0.png",
    description: "Sweet and fruity with a rainbow of flavors and colors.",
  },
  {
    name: "Gastro Pop",
    route: "/cultivars/gastro-pop",
    image: "/images/gastro-pop.png",
    description:
      "A fizzy, flavorful strain with a relaxing yet euphoric effect.",
  },
  {
    name: "Georgia",
    route: "/cultivars/georgia",
    image: "/images/georgia.png",
    description: "Smooth and mellow, perfect for unwinding after a long day.",
  },
  {
    name: "Island Pink",
    route: "/cultivars/island-pink",
    image: "/images/pink-kush.png",
    description: "A tropical delight with floral and fruity notes.",
  },
  {
    name: "Jealousy",
    route: "/cultivars/jealousy",
    image: "/images/jealousy.png",
    description:
      "A bold strain with a sweet and sour aroma that leaves a lasting impression.",
  },
  {
    name: "Jelly Breath",
    route: "/cultivars/jelly-breath",
    image: "/images/jelly-breath.png",
    description: "Dense, frosty buds with a sweet berry and vanilla flavor.",
  },
  {
    name: "Mac Donut",
    route: "/cultivars/mac-donut",
    image: "/images/mac-donut.png",
    description:
      "A decadent strain with sweet, doughy flavors and a balanced high.",
  },
  {
    name: "Master Kush Ultra",
    route: "/cultivars/master-kush-ultra",
    image: "/images/mk-ultra.png",
    description: "Deeply relaxing with a pungent earthy aroma.",
  },
  {
    name: "Peanut Butter Rockstar",
    route: "/cultivars/peanut-butter-rockstar",
    image: "/images/peanut-butter-rockstar.png",
    description: "Nutty and sweet with a heavy body high.",
  },
  {
    name: "Permanent Marker",
    route: "/cultivars/permanent-marker",
    image: "/images/permanent-marker.png",
    description: "Pungent and sticky with a unique, lingering aroma.",
  },
  {
    name: "Pine Tar",
    route: "/cultivars/pine-tar",
    image: "/images/pine-tar.png",
    description: "Strong pine scent with a classic earthy taste.",
  },
  {
    name: "Platinum Lemon Cherry Gelato",
    route: "/cultivars/platinum-lemon-cherry-gelato",
    image: "/images/platinum-lemon-cherry-gelato.png",
    description: "A zesty lemon-cherry delight with smooth effects.",
  },
  {
    name: "Rotten Runtz",
    route: "/cultivars/rotten-runtz",
    image: "/images/Runtz.png",
    description: "Sweet yet pungent with a funky, lingering aroma.",
  },
  {
    name: "Rockstar",
    route: "/cultivars/rockstar",
    image: "/images/rockstar.png",
    description: "Potent and relaxing with an earthy, spicy profile.",
  },
  {
    name: "White Runtz",
    route: "/cultivars/white-runtz",
    image: "/images/Runtz_white.png",
    description: "Frosty, candy-like buds with a euphoric high.",
  },
  {
    name: "Sleepy Joe OG",
    route: "/cultivars/sleepy-joe-og",
    image: "/images/sleepy-joe-og.png",
    description: "Perfect for nighttime relaxation and deep sleep.",
  },
  {
    name: "Tom Ford Pink",
    route: "/cultivars/tom-ford-pink",
    image: "/images/Kush.png",
    description: "Luxury strain with a heavy body high and rich flavors.",
  },
  {
    name: "Tropical Cherry Blast",
    route: "/cultivars/tropical-cherry-blast",
    image: "/images/tropical-cherry-blast.png",
    description: "Explosive cherry flavor with an uplifting effect.",
  },
  {
    name: "Zoap",
    route: "/cultivars/zoap",
    image: "/images/zoap.png",
    description: "A complex aroma with creamy, citrusy notes.",
  },
];

const Cultivars = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Cultivars | Premium Cannabis Strains</title>
        <meta
          name="description"
          content="Explore our premium cannabis cultivars, carefully crafted for quality, potency, and flavor. Discover the perfect strain for your experience."
        />
        <meta
          name="keywords"
          content="cannabis cultivars, premium strains, high-quality cannabis, best weed strains, Beyond Bloom strains, organic cannabis, indica, sativa, hybrid"
        />
      </Helmet>

      <Navbar />
      <section className="relative text-white py-16">
        {/* Vertical Sidebar */}
        <motion.div
          className="absolute left-0 top-0 h-full bg-green-500 text-black font-bold text-xl p-4 sm:p-6  items-center writing-mode-vertical-rl hidden sm:flex"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <p className="tracking-wide text-lg md:text-xl">OUR CULTIVARS</p>
        </motion.div>

        {/* Content Wrapper */}
        <div className="container mx-auto pl-4 sm:pl-24 md:pl-40 pr-4 sm:pr-10">
          {/* Cultivar Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-16">
            {cultivars.map((cultivar, index) => (
              <motion.div
                key={index}
                className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                {/* Wrap with Link */}
                <Link
                  to={cultivar.route}
                  className="relative block w-full max-w-[320px] sm:w-96 h-[400px] sm:h-[450px] mx-auto"
                >
                  <div className="w-full h-full flex items-center justify-center bg-black rounded-lg overflow-hidden">
                    <img
                      src={cultivar.image}
                      alt={cultivar.name}
                      className="w-full h-full object-contain rounded-lg"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/65 to-black opacity-60"></div>
                  <div className="absolute inset-0 p-6 sm:p-8 flex flex-col justify-end space-y-4">
                    <h3 className="text-lg sm:text-2xl font-extrabold text-green-500">
                      {cultivar.name}
                    </h3>
                    <p className="text-gray-300 text-sm">
                      {cultivar.description}
                    </p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Cultivars;
